import React from "react";
import AnimatedTimeline from "./AnimatedTimeline";
import Tag from "../../assets/About/Tag_journey.svg";

export default function TimeLine() {
  return (
    <div className="pt-10  bg-white w-full flex justify-center">
      {/* Journey Section */}
      <section className="max-w-[1440px] px-3 sm:px-[120px]">
        <div className="">
          <img src={Tag} alt="" />
          <h2
            className="text-left mb-4 font-montserrat md:text-[40px] text-[32px] font-[600] bg-clip-text text-transparent "
            style={{
              backgroundImage:
                "linear-gradient(to right, #000000 30%, #0060C7 70%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Where It All Began... and Where We're Going
          </h2>
        </div>

        {/* Timeline */}
        <div className="min-h-screen flex items-center justify-center bg-white font-montserrat">
          <div className="w-full max-w-6xl p-4">
            <AnimatedTimeline />
          </div>
        </div>
      </section>
    </div>
  );
}
